export default function MessageSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-12 items-center max-w-6xl mx-auto">
          <div className="lg:col-span-2">
            <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/0580f67af17d4e8abb7b9b14e416d311.jpeg"
                alt="代表 松田晋介"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3 space-y-6">
            <div>
              <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">Message</span>
            </div>
            
            <h2 className="text-4xl font-bold text-gray-900">
              代表からのメッセージ
            </h2>

            <div className="text-sm text-gray-600">
              <p className="font-medium">管理者／代表取締役</p>
              <p className="text-lg font-bold text-gray-900 mt-1">松田 晋介</p>
            </div>

            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                まごころヘルパーのホームページをご覧いただき、ありがとうございます。代表の松田晋介と申します。
              </p>
              <p>
                私たちは、逗子・葉山という美しい地域で、訪問介護サービスを提供しています。この地域に暮らす高齢者の方々が、住み慣れた我が家で安心して生活を続けられるよう、心を込めてサポートすることが私たちの使命です。
              </p>
              <p>
                介護の仕事は、決して楽なものではありません。しかし、ご利用者様の笑顔や「ありがとう」という言葉に触れるたび、この仕事の素晴らしさを実感します。人の人生に寄り添い、その方らしい生活を支えることができる、とてもやりがいのある仕事です。
              </p>
              <p>
                私たちは、スタッフ一人ひとりが成長し、やりがいを感じながら働ける環境づくりにも力を入れています。未経験の方でも安心してスタートできるよう、丁寧な研修とサポート体制を整えています。
              </p>
              <p>
                地域の皆様、そしてこれから一緒に働く仲間の皆様と共に、温かい介護サービスを提供し続けていきたいと考えています。どうぞよろしくお願いいたします。
              </p>
            </div>

            <div className="text-right pt-4">
              <p className="text-lg font-bold text-gray-900">松田 晋介</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
